import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
//Datapicker Module
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HttpClientModule } from '@angular/common/http';
import { NgOtpInputModule } from 'ng-otp-input';

import { NgbModule, NgbDateAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

import { sweetalert } from "./services/sweetalert";
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';

import { NgxSmartModalModule, NgxSmartModalService } from 'ngx-smart-modal';

import { LoaderComponent } from "./services/loader";
//import { LocationStrategy, HashLocationStrategy, PathLocationStrategy } from '@angular/common';
//import { NgxImageCompressService } from 'ngx-image-compress';

//import { MatButtonModule, MatDialogModule, MatTableModule, MatCheckboxModule } from '@angular/material';
import { MatDialogModule } from "@angular/material/dialog";

import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

import { TooltipModule } from 'ng2-tooltip-directive';
import { NgSelectModule } from '@ng-select/ng-select';

import { DatePipe } from '@angular/common';


import { AutocompleteLibModule } from 'angular-ng-autocomplete';

import { EmicardGeolocationComponent } from './emicard-geolocation/emicard-geolocation.component';
import { SelectcardComponent } from './selectcard/selectcard.component';
import { ManagecardComponent } from './managecard/managecard.component';
import { ShopOnlineComponent } from './shop-online/shop-online.component';
import { MfiScreenComponent } from './mfi-screen/mfi-screen.component';
import { QrlandingHomeComponent } from './qrlanding-home/qrlanding-home.component';
import { ExistingCustCardComponent } from './existing-cust-card/existing-cust-card.component';
import { NewCustCardComponent } from './new-cust-card/new-cust-card.component';
import { AutoTabDirectiveDirective } from './auto-tab-directive.directive';
import { otpservice } from './services/otpservice';
import { DealerDetailsComponent } from './dealer-details/dealer-details.component';
import { DealerLocatorComponent } from './dealer-locator/dealer-locator.component';
import { DealersComponent } from './dealers/dealers.component';
import { ThankYouPageComponent } from './thank-you-page/thank-you-page.component';
import { ShopOnlineHomeComponent } from './shop-online-home/shop-online-home.component';
import { ShopOnlineBrandsComponent } from './shop-online-brands/shop-online-brands.component';
import { EmandataScreenComponent } from './emandata-screen/emandata-screen.component';
import { HelperScreenComponent } from './helper-screen/helper-screen.component';




@NgModule({
  declarations: [
    AppComponent,
    LoaderComponent,
       EmicardGeolocationComponent,
       SelectcardComponent,
       ManagecardComponent,
       ShopOnlineComponent,
       MfiScreenComponent,
       QrlandingHomeComponent,
       ExistingCustCardComponent,
       NewCustCardComponent,
       AutoTabDirectiveDirective,
       DealerDetailsComponent,
       DealerLocatorComponent,
       DealersComponent,
       ThankYouPageComponent,
       ShopOnlineHomeComponent,
       ShopOnlineBrandsComponent,
       EmandataScreenComponent,
       HelperScreenComponent

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule.forRoot(),
    BrowserAnimationsModule,
    HttpClientModule,
    NgOtpInputModule,
    NgbModule,
    NgIdleKeepaliveModule.forRoot(),
    NgxSmartModalModule.forRoot(),
    MatDialogModule,
    NgxExtendedPdfViewerModule,
    TooltipModule,
    AutocompleteLibModule,
    NgSelectModule


  ],
  
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  exports: [],
  providers: [ otpservice ,sweetalert, NgxSmartModalService,  DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
